export default __webpack_public_path__ + "static/media/juridico.1a7f3029.svg";